export default __webpack_public_path__ + "static/media/May2017.ff9b57af.png";